<div class="p-6 rounded-2xl bg-white border border-gray-200 hover:border-transparent transition-colors duration-300 max-w-xl mx-auto h-full flex flex-col justify-between">
  <div>
    <!-- Reviewer Avatar & Name -->
    <div class="flex items-center gap-4 mb-4">
      @if (avatar) {
        <img [src]="avatar" [alt]="name" class="w-12 h-12 rounded-full object-cover border-2 border-[var(--primary)]/20" />
      } @else {
        <div class="w-12 h-12 rounded-full bg-[var(--primary)] text-white font-bold flex items-center justify-center text-sm">
          {{ getInitials(name) }}
        </div>
      }
      
      <div>
        <h4 class="text-gray-900 font-bold text-base leading-tight">{{ name }}</h4>
        <span class="text-xs font-semibold text-emerald-600 flex items-center gap-1">
          ✓ Verified Buyer
        </span>
      </div>
    </div>

    <!-- Stars -->
    <div class="flex items-center gap-1 mb-3 text-amber-400">
      @for (star of [].constructor(maxStars); track $index; let i = $index) {
        <fa-icon
          [icon]="i < rating ? solidStar : regularStar"
          size="sm"
        ></fa-icon>
      }
    </div>

    <!-- Review Message -->
    <p class="text-gray-600 text-sm leading-relaxed">
      "{{ showFull ? message : (message | slice:0:140) + (message.length > 140 ? '...' : '') }}"
    </p>
  </div>

  <!-- Read More Toggle -->
  @if (message.length > 140) {
    <button
      (click)="toggleShow()"
      class="text-[var(--primary)] mt-3 font-semibold text-xs hover:underline self-start cursor-pointer"
    >
      {{ showFull ? 'Show Less' : 'Read Full Review' }}
    </button>
  }
</div>
